/**
 * =======================================
 * Dialog Store
 * =======================================
 *
 * Handles the dialogs of the application.
 *
 * =======================================
 */
export default {
  namespaced: true,
  strict: process.env.APP_ENV === 'development',
  state () {
    return {
      alertDialog: false,
      confirmationDialog: false,
      codeConfirmationDialog: false,
      id: null,
      title: '',
      body: '',
      action: null,
      actionLabel: '',
      cancel: null,
      cancelLabel: '',
      maxWidth: 500,
      color: ''
    }
  },
  mutations: {
    /**
     * Shows the alert dialog.
     *
     * @param state
     * @param param1
     */
    openAlertDialog (state, { title, body, action, actionLabel, maxWidth }) {
      state.title = title
      state.body = body
      state.actionLabel = actionLabel || 'Got it!'
      state.action = action
      state.alertDialog = true
      state.maxWidth = maxWidth || 500
    },

    /**
     * Shows the code confirmation dialog.
     *
     * @param state
     * @param param1
     */
    openCodeConfirmationDialog (state, { action, body, id }) {
      state.action = action
      state.body = body
      state.codeConfirmationDialog = true
      state.id = id
    },

    /**
     * Shows the confirmation dialog.
     *
     * @param state
     * @param param1
     */
    openConfirmationDialog (state, { title, body, action, actionLabel, cancel, cancelLabel, color }) {
      state.title = title
      state.body = body
      state.actionLabel = actionLabel
      state.cancelLabel = cancelLabel
      state.action = action
      state.cancel = cancel
      state.confirmationDialog = true
      state.color = color || 'light-blue-darken-2'
    },

    /**
     * Hides the dialog in view.
     *
     * @param state
     * @param dialog
     */
    closeDialog (state, dialog) {
      state[dialog] = false
      state.title = false
      state.id = null
      state.title = ''
      state.body = ''
      state.actionLabel = ''
      state.cancelLabel = ''
    }
  },
  actions: {
    /**
     * Shows the alert dialog.
     *
     * @param context
     * @param config
     */
    showAlertDialog (context, config) {
      context.commit('openAlertDialog', config)
    },

    /**
     * Shows the code confirmation dialog.
     *
     * @param context
     * @param config
     */
    showCodeConfirmationDialog (context, config) {
      context.commit('openCodeConfirmationDialog', config)
    },

    /**
     * Shows the confirmation dialog.
     *
     * @param context
     * @param config
     */
    showConfirmationDialog (context, config) {
      context.commit('openConfirmationDialog', config)
    },

    /**
     * Hide the dialog in view.
     *
     * @param context
     */
    hideDialog (context) {
      context.commit('closeDialog')
    }
  }
}
